export interface AddressComponent {
  types: string[];
  short_name: string;
  long_name: string;
}

export const getLongFieldValue = (
  addressComponents: AddressComponent[],
  fields: string[],
): string => {
  return fields
    .map(f => {
      return addressComponents.find(addressComponent =>
        addressComponent.types.includes(f),
      )?.long_name;
    })
    .join(' ');
};

export const getShortFieldValue = (
  addressComponents: AddressComponent[],
  fields: string[],
): string => {
  return fields
    .map(f => {
      return addressComponents.find(addressComponent =>
        addressComponent.types.includes(f),
      )?.short_name;
    })
    .join(' ');
};
